// Bundled fallback strings; BE overrides merge on top in full mode. Missing → English.
export type LocaleBundle = Record<string, string>;

const loadLocaleFile = (lang: string): Promise<{ default: LocaleBundle }> => import(`./${lang}.json`);

export async function loadLocale(lang: string): Promise<LocaleBundle> {
  try {
    const mod = await loadLocaleFile(lang);
    return mod.default;
  } catch {
    if (lang !== 'en') {
      const fallback = await loadLocaleFile('en');
      return fallback.default;
    }
    return {};
  }
}
